<!--
 * @description: 产业园收发明细表
 * @author: ckj
 * @date: 2024/9/18 9:28
-->
<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <SearchInput ref="refSearchForm" @search="onSearch" @reset="resetQuery"/>
    </div>
    <div slot="btn">
      <a-space>
        <download-modal :apiFun="apiWmsSfMXZDetailExport" ref="download" />
        <a-button
          type="primary"
          @click="handleExport"
          v-hasPermi="['inv:invOnhandQuantities:wmsSfMXZDetailExport']"
        >导出</a-button>
      </a-space>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table ref="dataTable" :columns="columns" :tableProps="tableProps" rowKey="id"
                      :scroll="{ fixScreen: true, x: 1000 }">
          <template slot="dateFormat" slot-scope="data">
            {{ data.text && $moment(data.text).format('YYYY-MM-DD HH:mm:ss') }}
          </template>
        </ls-api-table>
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { mapState } from 'vuex'
import {
  apiGetWmsSfMXZDetailList,
  apiWmsSfMXZDetailExport
} from '@/api/report/receipt-send-details'
import { generateLsTableResData } from '@/utils/util.js'
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
import SearchInput from './components/search-input'
import cloneDeep from 'lodash.clonedeep'

export default {
  // eslint-disable-next-line
  name: 'Receipt-send-details', // name要和rms配置菜单路由保存一致(首字母大写)
  components: { DownloadModal, SearchInput },
  computed: {
    ...mapState({
      organizationCodeOrigin: (state) => state.user.organizationCode
    })
  },
  data() {
    return {
      apiWmsSfMXZDetailExport,
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiGetWmsSfMXZDetailList, true),
        pageCurrent: true
      },
      // 控制搜索展开
      advanced: true,
      // 查询参数
      queryParams: {
        wipEntityName: undefined,
        orgCode: undefined,
        sublibraryCode: undefined,
        orderType: undefined,
        itemCode: undefined,
        supplierCode: undefined,
        lotName: undefined
      },
      // 表格数据
      tableList: [],
      // 表格字段
      columns: [
        {
          title: '工单号',
          dataIndex: 'gdh',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '组织编码',
          dataIndex: 'zzbm',
          align: 'center',
          width: 120,
          ellipsis: true
        },
        {
          title: '组织名称',
          dataIndex: 'zzmc',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '子库名称',
          dataIndex: 'zkmc',
          align: 'center',
          width: 200,
          ellipsis: true
        },
        {
          title: '子库代码',
          dataIndex: 'tenantId',
          align: 'center',
          width: 100,
          ellipsis: true
        },
        {
          title: '收货单',
          dataIndex: 'shd',
          align: 'center',
          width: 120,
          ellipsis: true
        },
        {
          title: '外部单号',
          dataIndex: 'wbdh',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '单据类型',
          dataIndex: 'djlx',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '标签ID',
          dataIndex: 'jhlsh',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '单据行号',
          dataIndex: 'djhh',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '物料编码',
          dataIndex: 'wlbm',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '物料名称',
          dataIndex: 'wlmc',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '规格描述',
          dataIndex: 'ggms',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '货品分类',
          dataIndex: 'hpfl',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '需求数量',
          dataIndex: 'xqsl',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '配送数量',
          dataIndex: 'pssl',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '拣货库位',
          dataIndex: 'jhkw',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '单位',
          dataIndex: 'unit',
          align: 'center',
          width: 100,
          ellipsis: true
        },
        {
          title: '预收货量',
          dataIndex: 'yqsl',
          align: 'center',
          width: 100,
          ellipsis: true
        },
        {
          title: '实收数量',
          dataIndex: 'shsl',
          align: 'center',
          width: 100,
          ellipsis: true
        },
        {
          title: '采购类型',
          dataIndex: 'cgtype',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '供应商编码',
          dataIndex: 'gysbm',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '供应商名称',
          dataIndex: 'gysmc',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '生产批次',
          dataIndex: 'scpc',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '出库单号',
          dataIndex: 'ckdh',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '源子库',
          dataIndex: 'yzk',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '收货时间',
          dataIndex: 'shsj',
          scopedSlots: { customRender: 'dateFormat' },
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '配送时间',
          dataIndex: 'fysj',
          scopedSlots: { customRender: 'dateFormat' },
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '配送人',
          dataIndex: 'fyr',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '交货日期',
          dataIndex: 'jhrq',
          scopedSlots: { customRender: 'dateFormat' },
          align: 'center',
          width: 150,
          ellipsis: true
        }
      ]
    }
  },
  created() { },
  mounted() {
    this.$refs.refSearchForm.$refs.searchForm.handleSearch()
  },
  methods: {
    // 表单搜索
    onSearch(value = {}) {
      const params = value
      delete params.searchFormLabel
      this.$store.commit('setCashHistory', { path: this.$route.fullPath, data: cloneDeep(params) })
      this.$refs.dataTable.searchParams = params
      this.$refs.dataTable.getData()
    },
    // 新增/修改框事件
    handleOk() {
      this.onSearch()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParams = {
        zzbm: this.$refs.dataTable.searchParams.zzbm,
        wbdh: undefined,
        shd: undefined,
        ckdh: undefined,
        psDate: undefined,
        jhDate: undefined,
        shDate: undefined,
        scpc: undefined,
        jhlsh: undefined,
        itemCode: undefined,
        djlxTypes: undefined,
        tenantId: undefined,
        gdh: undefined
      }
      this.$refs.dataTable.searchParams = this.queryParams
      // this.$refs.refSearchForm.$refs.searchForm.form.setFieldsValue(this.queryParams)
    },
    // 搜索框展开、收起
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    // 导出
    handleExport() {
      const params = this.$refs.dataTable.searchParams
      this.$refs.download.openModal(params)
    }
  }
}
</script>

<style scoped lang="less"></style>
